import { MessageBar, Panel, PanelType, PrimaryButton, ProgressIndicator, Separator, Stack, TextField, Toggle } from '@fluentui/react';
import * as React from 'react';
import LoginIcon from '../../../Images/LoginLogo';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IProfileContact } from '../../../Models/Profile/IProfileContact'
import { InvoiceContactForm } from './InvoiceContactForm';

interface IInvoiceContactViewProps {
    contactInfo: IProfileContact;
    saveProfile: () => void;
    changeInfoProperty: (key: string, value: any) => void;
    statusMessage?: IStatusMessage;
    isLoading: boolean;
    
}

export const InvoiceContactView: React.FunctionComponent<IInvoiceContactViewProps> = (props) => {

    const [isValid, setIsValid] = React.useState(false);
    const [isValidBilling, setIsValidBilling] = React.useState(false);
    

    const firmaChanged = (event?: React.MouseEvent<HTMLElement>, checked?: boolean) => {      
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.changeInfoProperty(id, checked ? true : false);
        }
    }

    const setInfoChange = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.changeInfoProperty(id, newValue);
        }
    }
 

    return (<Stack horizontalAlign="center">
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: {paddingTop: 40  } }}>
            <Stack horizontalAlign="center" >
                <LoginIcon />
            </Stack>
            <Separator styles={{ root: { marginTop: 0 } }}>Kontaktní údaje</Separator>
            <InvoiceContactForm
                isValid={setIsValid}
                isValidBilling={setIsValidBilling }
                contactInfo={props.contactInfo}
                isLoading={props.isLoading}
                propertyChanged={props.changeInfoProperty}
            />
            <Stack>
                <Stack styles={{ root: { paddingTop: 15 } }} horizontalAlign="center">
                    <PrimaryButton disabled={!(isValid && isValidBilling)} text="Uložit" onClick={props.saveProfile} />
                </Stack>
                {props.isLoading ? <ProgressIndicator></ProgressIndicator> : null}
                <br/>
                {props.statusMessage && props.statusMessage.message ? <MessageBar styles={{ root: { marginTop: 30 } }} messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
            </Stack>
        </Stack>
    </Stack>)
}
